import { observer } from 'mobx-react';
import * as React from 'react';
import { ExperienceResource } from '../../../../Types';
import LearningCollectionEditStore from '../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../Types';
import ExperienceRowItems from '../Experiences/CustomizeRow/ExperienceRowItems';
import ExperienceRowItemsWithHandlers from './ExperienceRowItemsWithHandlers';

interface Props {
  context: ModifiableExperiencesContext;
  experienceResource: ExperienceResource;
  store: LearningCollectionEditStore;
}

const CustomizeRow: React.FC<Props> = ({ context, experienceResource, store }) => {
  switch (context.kind) {
    case 'section-context':
      switch (context.section.resource.payload.learningDesignState) {
        case 'curated':
          return (
            <ExperienceRowItems
              context={context}
              experienceResource={experienceResource}
              store={store}
              showLockIcon="show"
            />
          );
        case 'curated-custom':
        case 'custom':
        case 'empty':
        case 'blank':
        case 'build-your-own':
        case 'browse-all':
          return (
            <ExperienceRowItemsWithHandlers
              context={context}
              store={store}
              experienceResource={experienceResource}
              showLockIcon="show"
            />
          );
      }
    case 'browse-all-experiences':
      return (
        <ExperienceRowItemsWithHandlers
          context={context}
          store={store}
          showLockIcon="hide"
          experienceResource={experienceResource}
        />
      );
  }
};

export default observer(CustomizeRow);
